import { render, staticRenderFns } from "./buy_animals.vue?vue&type=template&id=3c7fa19e&"
import script from "./buy_animals.vue?vue&type=script&lang=js&"
export * from "./buy_animals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports